import { Component } from '@angular/core';
import { ModalService } from 'src/app/modal';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-test',
    templateUrl: './test.component.' + environment.brand + '.html',
    styleUrls: ['./test.component.' + environment.brand + '.css'],
    providers: []
})
export class TestComponent {

    cars: string[] = [];

    constructor(private modalService: ModalService) {
        if (environment.brand == 'vwsa') {
            this.cars.push('Polo Vivo Hatch');
            this.cars.push('Polo Vivo Sedan');
            this.cars.push('Jetta 1.6');
            this.cars.push('Jetta TDI');
            this.cars.push('Kombi');
        } else {
            this.cars.push('A1');
            this.cars.push('A3 Sedan');
            this.cars.push('S3');
            this.cars.push('RS3 Hatch');
            this.cars.push('A4');
        }
    }

    openModal(id: string) {
        this.modalService.open(id);
    }
}
